(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["shared"] = factory();
	else
		root["lib"] = root["lib"] || {}, root["lib"]["shared"] = factory();
})(window, function() {
return 